import type React from 'react';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';
import { StatementsPageView } from './StatementsPageView';
import { useStatementsPage } from './useStatementsPage';

/**
 * `/accounting/statements` — the tab shell every `/accounting/statements*`
 * URL renders.
 *
 * The experiment's fourth grouping: the published statements. Separated from
 * Books because these are outputs rather than the ledger itself — Books is what
 * you keep, this is what you hand over. Each tab owns its data and its own
 * `ErrorBoundary`, so this shell holds neither.
 */
export const StatementsPage: React.FC = () => {
    const page = useStatementsPage();

    return (
        <div
            className="flex w-full flex-col gap-6"
            {...getNodeTestIdProp('statements-page')}
        >
            <StatementsPageView
                fromDate={page.fromDate}
                onRangeChange={page.onRangeChange}
                outletContext={page.outletContext}
                selectedTabId={page.selectedTabId}
                tabs={page.tabs}
                toDate={page.toDate}
            />
        </div>
    );
};
